import React, { useEffect, useState, useLayoutEffect } from "react";
import { Route, withRouter } from "react-router";

// components
import Loader from "../../Container/Loader";
import Modal from "../../Container/Modal";

// img
import Pen from "../../Assets/pen.svg";
import Handle from "../../Assets/handle.svg";

import HomeStyle from "./style";
import DeleteIcon from "../../Assets/Delete.svg";
import FullSidebarService from "../../Container/FullPageSidebar/services";

import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";

// -- redux
import { connect } from "react-redux";
import {
  GetServices,
  UpdateServiceStatus,
  DeleteService,
  UpdateServiceOrderStatus,
  ResetAddServiceData,
} from "../../Redux/Actions/ServicesAction";

function Services(props) {
  const initialPath = process.env.REACT_APP_IMAGE_BASE_URL;
  const [OpenModal, setModal] = useState(false);
  const [ServiceId, setServiceId] = useState(false);
  const [services, setServices] = useState([]);
  const [InitialArray, setInitialArray] = useState([]);
  const [Name, setName] = useState(false);

  useEffect(() => {
    let data = {
      status: props.status,
      user_type: props.userData,
      module_type: 0,
    };
    props.GetServices(data);
    props.ResetAddServiceData();
  }, [
    props.update_data,
    props.delete_data,
    props.location.back,
    props.order_data,
    props.status,
    props.userData,
    props.add_data,
    props.edit_data,
  ]);

  useEffect(() => {
    if (props.data && props.data.data && props.data.data.data) {
      props.enabled(props.data.data.enabled);
      props.disabled(props.data.data.disabled);
      setInitialArray(props.data.data.data);
      props.clear("");
    }
  }, [
    props.data,
    props.update_data,
    props.delete_data,
    props.add_data,
    props.edit_data,
  ]);

  useEffect(() => {
    props.clear("clear");
  }, []);

  useEffect(() => {
    if (props.data && props.data.data && props.data.data.data) {
      setServices(InitialArray);
    }
  }, [InitialArray]);

  const handleModal = (e, type, name, id) => {
    e.preventDefault();
    setModal(type);
    setName(name);
    setServiceId(id);
  };

  const CloseModal = (e, type) => {
    e.preventDefault();
    if (type === "enable_yes") {
      let body = {
        id: ServiceId,
        status: 0,
      };
      props.UpdateServiceStatus(body);
    } else {
      setModal(!OpenModal);
    }
    if (type === "disable_yes") {
      let body = {
        id: ServiceId,
        status: 1,
      };
      props.UpdateServiceStatus(body);
    } else {
      setModal(!OpenModal);
    }
    if (type === "delete_yes") {
      props.DeleteService(ServiceId);
      setModal(false);
    } else if (type === "delete_no") {
      setModal(false);
    }
  };

  const Search = props.Search;
  useEffect(() => {
    if (!Search) {
      setServices(InitialArray);
    }
    if (Search.length > 2) {
      const FilteredArray = InitialArray.filter((post) => {
        const postTitle = post.title;
        const postHeaderTitle = post.header_title;
        return (
          postTitle.toLowerCase().includes(Search.toLowerCase()) ||
          postHeaderTitle.toLowerCase().includes(Search.toLowerCase())
        );
      });
      setServices(FilteredArray);
    }
  }, [Search]);

  const handleOnDragEnd = (result) => {
    if (!result.destination) return;
    const items = Array.from(services);
    const [reorderedItem] = items.splice(result.source.index, 1);
    items.splice(result.destination.index, 0, reorderedItem);
    setServices(items);
    passData(items);
  };

  const passData = (items) => {
    let data = [];
    items.map((arr) => {
      let index = items.findIndex((x) => x.title === arr.title);
      let id = items.filter((x) => x.id === arr.id);
      data.push({
        id: id[0].id,
        order_number: index + 1,
      });
    });
    props.UpdateServiceOrderStatus(data);
  };

  const changePage = (item) => {
    props.history.push({
      pathname: "services/edit-services",
      state: item,
      page: "services",
    });
  };

  const showAMPM = (time) => {
    let AMPM = "";
    let hourStr = "";
    let minStr = "";
    if (time) {
      let hours = parseInt(time.split(":")[0], 10);
      let minutes = parseInt(time.split(":")[1], 10);
      if (hours > 11) {
        if (hours > 12) hours = hours - 12;
        AMPM = "PM";
      } else {
        AMPM = "AM";
        if (hours === 0) hours = 12;
      }
      if (hours < 10) {
        hourStr = "0" + String(hours);
      } else {
        hourStr = String(hours);
      }
      if (minutes < 10) {
        minStr = "0" + String(minutes);
      } else {
        minStr = String(minutes);
      }
      return hourStr + " : " + minStr + " " + AMPM;
    } else {
      return time;
    }
  };

  const useSortableData = (items, config = null) => {
    const [sortConfig, setSortConfig] = React.useState(config);

    const sortedItems = React.useMemo(() => {
      let sortableItems = [...items];
      if (sortConfig !== null) {
        sortableItems.sort((a, b) => {
          if (a[sortConfig.key] < b[sortConfig.key]) {
            return sortConfig.direction === "ascending" ? -1 : 1;
          }
          if (a[sortConfig.key] > b[sortConfig.key]) {
            return sortConfig.direction === "ascending" ? 1 : -1;
          }
          return 0;
        });
      }
      return sortableItems;
    }, [items, sortConfig]);

    const requestSort = (key) => {
      let direction = "ascending";
      if (
        sortConfig &&
        sortConfig.key === key &&
        sortConfig.direction === "ascending"
      ) {
        direction = "descending";
      }
      setSortConfig({ key, direction });
    };

    return { items: sortedItems, requestSort, sortConfig };
  };
  const { items } = useSortableData(services);

  useLayoutEffect(() => {
    setTimeout(() => {
      if (
        props.location.method &&
        props.location.method === "add" &&
        props.add_data
      ) {
        props.respType({
          type: "Services",
          method: props.location.method,
          response: props.add_data,
        });
      }
    }, 1500);
  }, [props.add_data]);

  useLayoutEffect(() => {
    setTimeout(() => {
      if (
        props.location.method &&
        props.location.method === "update" &&
        props.edit_data
      ) {
        props.respType({
          type: "Services",
          method: props.location.method,
          response: props.edit_data,
        });
      }
    }, 1500);
  }, [props.edit_data]);

  useLayoutEffect(() => {
    setTimeout(() => {
      if (
        props.location.method &&
        props.location.method === "delete" &&
        props.delete_data
      ) {
        props.respType({
          type: "Services",
          method: props.location.method,
          response: props.delete_data,
        });
      }
    }, 1500);
  }, [props.edit_data, props.add_data, props.delete_data]);

  return (
    <>
      {props.loading && <Loader />}
      <div className="ml-4 mr-2">
        <Route
          exact
          path={[
            "/dashboard/services/add-services",
            "/dashboard/services/edit-services",
          ]}
          render={() => <FullSidebarService add_data={props.add_data} />}
        />
        {props.location.pathname === "/dashboard/services" && (
          <div className="module-table-wrap w-100 table-responsive">
            <div className="table-wrap">
              <table className="table table-bordered m-0">
                <thead className="text-grey-6">
                  <tr>
                    <th scope="col" className="dark-background" />
                    <th scope="col" className="dark-background">
                      <div className="d-flex justify-content-between">
                        <span className="f-16">Icon</span>
                      </div>
                    </th>
                    <th
                      scope="col"
                      className="dark-background cursor-pointer"
                      // onClick={() => requestSort('title')}
                    >
                      <div className="d-flex justify-content-between">
                        <span className="f-16">Title</span>
                        {/*<img src={Sort} alt="sort" className="ml-2"/>*/}
                      </div>
                    </th>
                    <th scope="col" className="dark-background">
                      <div className="d-flex justify-content-between">
                        <span className="f-16">Count of Questions</span>
                      </div>
                    </th>
                    <th scope="col" className="dark-background">
                      <div className="d-flex justify-content-between">
                        <span className="f-16">Header Title</span>
                      </div>
                    </th>
                    <th scope="col" className="dark-background">
                      <div className="d-flex justify-content-between">
                        <span className="f-16">New Request Button Title</span>
                      </div>
                    </th>
                    <th
                      scope="col"
                      className="dark-background cursor-pointer"
                      // onClick={() => requestSort('user_type')}
                    >
                      <div className="d-flex justify-content-between">
                        <span className="f-16">User type</span>
                        {/*<img src={Sort} alt="sort" className="ml-2"/>*/}
                      </div>
                    </th>
                    <th scope="col" className="dark-background">
                      <div className="d-flex justify-content-between">
                        <span className="f-16">Start Time</span>
                      </div>
                    </th>
                    <th scope="col" className="dark-background">
                      <div className="d-flex justify-content-between">
                        <span className="f-16">End Time</span>
                      </div>
                    </th>
                    <th scope="col" className="dark-background cursor-pointer">
                      <div className="d-flex justify-content-between">
                        <span className="f-16">Type</span>
                      </div>
                    </th>
                    <th scope="col" className="dark-background">
                      <span className="f-16">Status</span>
                    </th>
                    <th scope="col" className="dark-background">
                      <span className="f-16">Action</span>
                    </th>
                  </tr>
                </thead>
                <DragDropContext onDragEnd={handleOnDragEnd}>
                  <Droppable droppableId="home_listing" type="listing">
                    {(provided) => (
                      <tbody
                        {...provided.droppableProps}
                        ref={provided.innerRef}
                      >
                        {items.length > 0 ? (
                          items.map((item, index) => {
                            let user = "";

                            item.service_role &&
                              item.service_role.map((value) => {
                                if (value.role_id == 2) {
                                  user += "Personal Banking,";
                                }
                                if (value.role_id == 3) {
                                  user += "Business,";
                                }
                                if (value.role_id == 5) {
                                  user += "V1be User,";
                                }
                              });

                            return (
                              <Draggable
                                key={item.id}
                                draggableId={item.id.toString()}
                                index={index}
                              >
                                {(provided) => (
                                  <tr
                                    ref={provided.innerRef}
                                    {...provided.draggableProps}
                                    {...provided.dragHandleProps}
                                    key={index}
                                  >
                                    <td
                                      style={{ width: "69px" }}
                                      className="light-grey-background"
                                    >
                                      <img
                                        className="pl-4 pr-4"
                                        src={Handle}
                                        alt="Handle"
                                      />
                                    </td>
                                    <td
                                      style={{ width: "79px" }}
                                      className="light-grey-background"
                                    >
                                      <img
                                        width="40"
                                        src={item.icon}
                                        className="pl-1 pr-1"
                                        alt="icon"
                                      />
                                    </td>
                                    <td
                                      style={{ width: "132px" }}
                                      className="light-grey-background"
                                    >
                                      <span className="text-white pl-2 pr-2">
                                        {item.title}
                                      </span>
                                    </td>
                                    <td
                                      style={{ width: "191px" }}
                                      className="light-grey-background"
                                    >
                                      <span className="text-white pl-1">
                                        {item.question_count}
                                      </span>
                                    </td>
                                    <td
                                      style={{
                                        whiteSpace: "unset",
                                        wordBreak: "break-all",
                                      }}
                                      className="light-grey-background"
                                    >
                                      <p
                                        className="text-white m-0 pl-2"
                                        style={{ width: "239px" }}
                                      >
                                        {item.header_title}
                                      </p>
                                    </td>
                                    <td
                                      style={{
                                        width: "239px",
                                        whiteSpace: "unset",
                                        wordBreak: "break-all",
                                      }}
                                      className="light-grey-background"
                                    >
                                      <p
                                        className="text-white m-0 pl-2"
                                        style={{ width: "239px" }}
                                      >
                                        {item.request_button_title}
                                      </p>
                                    </td>
                                    <td
                                      style={{ width: "118px" }}
                                      className="light-grey-background"
                                    >
                                      <span className="text-white pl-2">
                                        {user.substring(0, user.length - 1)}
                                      </span>
                                    </td>
                                    <td
                                      style={{ width: "125px" }}
                                      className="light-grey-background"
                                    >
                                      <span className="text-white pl-1">
                                        {item.start_time &&
                                          showAMPM(item.start_time)}
                                      </span>
                                    </td>
                                    <td
                                      style={{ width: "82px" }}
                                      className="light-grey-background"
                                    >
                                      <span className="text-white pl-1">
                                        {item.end_time &&
                                          showAMPM(item.end_time)}
                                      </span>
                                    </td>
                                    <td
                                      style={{ width: "87px" }}
                                      className="light-grey-background"
                                    >
                                      <span className="text-white pl-1">
                                        {item.type === 1 && "Tab"}
                                        {item.type === 2 && "App"}
                                        {item.type === 3 && "Service"}
                                        {item.type === 4 && "Webview"}
                                        {item.type === 5 && "Form"}
                                      </span>
                                    </td>
                                    <td
                                      className="text-center pl-4 pr-4 light-grey-background"
                                      style={{ width: "108px" }}
                                    >
                                      <label className="switch mb-0">
                                        <input
                                          type="checkbox"
                                          checked={item.status === 1}
                                          readOnly
                                          onClick={(e) =>
                                            handleModal(
                                              e,
                                              item.status === 1
                                                ? "enable"
                                                : "disable",
                                              item.title,
                                              item.id
                                            )
                                          }
                                        />
                                        <span className="slider round" />
                                      </label>
                                    </td>
                                    <td
                                      style={{ width: "95px" }}
                                      className="light-grey-background"
                                    >
                                      <div className="d-flex">
                                        <img
                                          onClick={() => changePage(item.id)}
                                          src={Pen}
                                          alt="pen"
                                          className="ml-2 mr-2 cursor-pointer"
                                        />
                                        <img
                                          onClick={(e) =>
                                            handleModal(
                                              e,
                                              "delete",
                                              item.title,
                                              item.id
                                            )
                                          }
                                          src={DeleteIcon}
                                          alt="Delete"
                                          className="ml-2 cursor-pointer pr-3"
                                        />
                                      </div>
                                    </td>
                                  </tr>
                                )}
                              </Draggable>
                            );
                          })
                        ) : (
                          <tr>
                            <td colSpan="12" className="text-center">
                              <b className="text-white">Not found</b>
                            </td>
                          </tr>
                        )}
                      </tbody>
                    )}
                  </Droppable>
                </DragDropContext>
              </table>
              <HomeStyle />
            </div>
          </div>
        )}
        {OpenModal && (
          <Modal
            Name={Name}
            Type={OpenModal}
            Close={(e, type) => CloseModal(e, type)}
          />
        )}
      </div>
    </>
  );
}

const mapStateToProps = ({ ServicesReducer }) => {
  const {
    loading,
    table_loading,
    data,
    delete_data,
    update_data,
    order_data,
    add_data,
    edit_data,
  } = ServicesReducer;
  return {
    loading,
    table_loading,
    data,
    delete_data,
    update_data,
    order_data,
    add_data,
    edit_data,
  };
};

const mapDispatchToProps = {
  GetServices,
  UpdateServiceStatus,
  DeleteService,
  UpdateServiceOrderStatus,
  ResetAddServiceData,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(Services));
